import QuoteLineHeaderElement from "./QuoteLineHeaderElement";
interface QuoteLineHeaderProps {
  RFSdate: string | null;
  dueDate: string | null;
  customerProjectNumber: string | null;
  endCustomerName: string | null;
  customerName: string | null;
  createdAt: string | null;
  localContactName: string | null;
  localContactNumber: string | null;
}

export default function QuoteLineHeader(props: QuoteLineHeaderProps) {
  const validProps = Object.entries(props).filter(
    ([_, value]) => value !== null
  );

  if (validProps.length === 0) {
    return null;
  }
  const propsToRender = validProps.map(([key, value]) => {
    if (
      key.toLocaleLowerCase().includes("date") ||
      key.toLocaleLowerCase().includes("created")
    ) {
      return { key, value, dataType: "time" };
    }
    return { key, value, dataType: "string" };
  });
  return (
    <div className="w-full mb-5 gap-4 max-w-screen flex flex-wrap 2xl:justify-between xl:justify-start ">
      {propsToRender.map(({ key, value, dataType }) => (
        <div
          className="flex flex-col max-w-1/4 text-center bg-white px-4 py-1 rounded-lg min-w-[234px] font-kanit text-base font-lg font-light"
          key={key}
        >
          <QuoteLineHeaderElement
            keyIdentifier={key}
            value={value}
            dataType={dataType as "string" | "time"}
          />
        </div>
      ))}
    </div>
  );
}
